import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=a20e775a&scoped=true&"
import script from "./Archive.vue?vue&type=script&lang=js&"
export * from "./Archive.vue?vue&type=script&lang=js&"
import style0 from "./Archive.vue?vue&type=style&index=0&id=a20e775a&prod&lang=css&"
import style1 from "./Archive.vue?vue&type=style&index=1&id=a20e775a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20e775a",
  null
  
)

export default component.exports